module.exports = __webpack_public_path__ + "static/media/Identify.8e980710.jpg";